<script lang="ts">
  import { haptic } from "../lib/tg";

  let {
    open = $bindable(false),
    onsubmit,
  }: {
    open?: boolean;
    onsubmit?: (text: string) => Promise<boolean>;
  } = $props();

  let text = $state("");
  let sending = $state(false);
  let ta: HTMLTextAreaElement | null = $state(null);

  $effect(() => {
    if (open && ta) setTimeout(() => ta?.focus(), 200);
  });

  async function submit() {
    const t = text.trim();
    if (!t || !onsubmit) return;
    haptic("medium");
    sending = true;
    try {
      if (await onsubmit(t)) {
        text = "";
        open = false;
      }
    } finally {
      sending = false;
    }
  }
</script>

{#if open}
  <div class="backdrop" onclick={() => !sending && (open = false)} role="presentation"></div>
  <div class="sheet" role="dialog" aria-label="Заметка к сделке">
    <div class="grab"></div>
    <div class="title">Заметка в amoCRM</div>
    <textarea bind:this={ta} bind:value={text} maxlength="4000"
              placeholder="Например: клиент просит перенести замер на субботу"></textarea>
    <div class="actions">
      <button class="btn ghost" onclick={() => (open = false)} disabled={sending} type="button">Отмена</button>
      <button class="btn primary" onclick={submit} disabled={!text.trim() || sending} type="button">
        {sending ? "Отправляю…" : "Добавить"}
      </button>
    </div>
  </div>
{/if}

<style>
  .backdrop { position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 60; animation: fade 160ms ease; }
  .sheet {
    position: fixed; left: 0; right: 0; bottom: 0;
    background: var(--bg-elev);
    border-top-left-radius: 22px; border-top-right-radius: 22px;
    padding: 12px 18px calc(18px + var(--safe-bottom, 0px));
    box-shadow: var(--shadow-lg);
    z-index: 70;
    animation: slide 220ms cubic-bezier(.2,.8,.2,1);
  }
  .grab { width: 36px; height: 4px; background: var(--border-strong); border-radius: 2px; margin: 0 auto 12px; }
  .title { font-family: 'Manrope', sans-serif; font-weight: 700; font-size: 15px; margin-bottom: 12px; }
  textarea {
    width: 100%; box-sizing: border-box; min-height: 96px;
    background: var(--bg-elev-2); border: 1px solid var(--border); border-radius: 10px;
    padding: 10px 12px; color: var(--text); font-family: inherit; font-size: 16px; resize: none;
  }
  textarea:focus { border-color: var(--ember); outline: none; }
  .actions { display: grid; grid-template-columns: 1fr 1.6fr; gap: 8px; margin-top: 14px; }
  .btn { height: 46px; border-radius: 12px; font-family: 'Manrope', sans-serif; font-weight: 600; font-size: 14px; cursor: pointer; }
  .btn:active { filter: brightness(0.92); }
  .btn.ghost { background: var(--bg-elev-2); color: var(--text); border: 1px solid var(--border); }
  .btn.primary { background: var(--ember); color: #fff; border: none; }
  .btn:disabled { opacity: 0.4; cursor: not-allowed; }
  @keyframes fade { from { opacity: 0; } to { opacity: 1; } }
  @keyframes slide { from { transform: translateY(100%); } to { transform: translateY(0); } }
  @media (prefers-reduced-motion: reduce) { .sheet, .backdrop { animation: none; } }
</style>
